import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function Divider({ kind }) {
    if (kind === 'line') {
        return <hr className="cms-divider" />;
    }

    return <div className={classnames('cms-divider', `cms-divider__${ kind }`)} style={{ height: 1 }} />;
}

Divider.propTypes = {
    kind: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/divider/index.js